import { createContext, useContext } from 'react'

export interface SiteUrlContextValue {
    originalPath: string
    originalQuery: Record<string, string | string[]>
    originalUrl: string
}

const defaultValue: SiteUrlContextValue = {
    originalPath: '',
    originalQuery: {},
    originalUrl: '',
}

export const SiteUrlContext = createContext<SiteUrlContextValue>(defaultValue)
export const SiteUrlProvider = SiteUrlContext.Provider
export const useSiteUrl = () => useContext(SiteUrlContext)
